import {Injectable} from '@angular/core';

@Injectable()
export class Utils {
  static instance: Utils;
  static isCreating: Boolean = false;

  constructor(){
    if(!Utils.isCreating){
      throw new Error("You can't call new in Singleton instances!");
    }
  }

  static getInstance(){
    if(Utils.instance == null){
      Utils.isCreating = true;
      Utils.instance = new Utils();
      Utils.isCreating = false;
    }
    return Utils.instance;
  }

  public static toArray(targetObject) {
    if(!targetObject){return [];}
    var arr:any = [];
    Object.keys(targetObject).forEach(
      function (key) {
        //skip timestampCreated/Modified
        if(key !== 'timestampCreated' && key != 'timestampModified'){
          arr.push({
            key: key,
            value: targetObject[key]
          });
        }
      }
    );

    return arr;
  }

  public static toAngularFireArray(targetObject) {
    if(!targetObject || targetObject.hasOwnProperty("$value")){return [];}
    var arr:any = [];
    Object.keys(targetObject).forEach(
      function (key) {
        //skip timestampCreated/Modified
        if(key !== 'timestampCreated' && key != 'timestampModified'  && key != '$key' && key !='$exists'){
          let object = targetObject[key];
          object.$key = key
          arr.push(object);
        }
      }
    );

    return arr;
  }
  public static arrayValues(targetObject) {
    return Object.keys(targetObject).map(
      function (key) {
        return targetObject[key]
      }
    );
  }

  public static arrayKeys(targetObject) {
    return Object.keys(targetObject).map(
      function (key) {
        return key;
      }
    );
  }

  public static sortArray(targetObject, sortOptions) {
    console.log(targetObject)
    var sortProperty = sortOptions.property.toLowerCase();
    if(sortProperty == 'date') {
      sortProperty = "timestamp_created";
    }
    switch(sortOptions.method){
      case 'asc':
        //
        return targetObject.sort(compareDesc);
      
      case 'desc':
        //
        return targetObject.sort(compareAsc);
      
    }
    function compareDesc(a,b) {
        a = a['value'];
        b = b['value'];
        console.log(a, b)
        if (a[sortProperty] < b[sortProperty])
            return -1;
        else if (a[sortProperty] > b[sortProperty])
            return 1;
        else
            return 0;
    };
    function compareAsc(a,b) {
        a = a['value'];
        b = b['value'];
        if (a[sortProperty] > b[sortProperty])
            return -1;
        else if (a[sortProperty] < b[sortProperty])
            return 1;
        else
            return 0;
    };
  }

  public static capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  public static getFirstInitials(str){
    if(!str){return '';}
    let names = str.split(" ");
    
    return names[0].charAt(0).toUpperCase() + (names.length > 1 ? names[names.length - 1].charAt(0).toUpperCase() : "");
  }

  public static formatTimestamp(timestamp) {
    let date = new Date(timestamp);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
  }
  
  public static timeSince(unix_timestamp) {
    
    let date = +new Date(unix_timestamp);
    let seconds = Math.floor((+new Date() - date) / 1000);
    let interval = Math.floor(seconds / 31536000);
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    
    // if (interval > 1) {
    //     return interval + " years";
    // }
    // interval = Math.floor(seconds / 2592000);
    // if (interval > 1) {
    //     return interval + " months";
    // }
    interval = Math.floor(seconds / 86400);
    if(interval == 1){
      return "yesterday";
    }else if (interval > 1) {
        let d = new Date(unix_timestamp);
        return "on " + months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
        return interval + " minutes";
    }
    //return Math.floor(seconds) + " seconds";
    return "just now";
  }

  public static formatNumberToString(number, digits = 2){
    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9,  symbol: "G" },
      { value: 1E6,  symbol: "M" },
      { value: 1E3,  symbol: "K" }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (number >= si[i].value) {
        return (number / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }
    return number.toFixed(digits).replace(rx, "$1");
  }

  public static stateList(){
    var statelist = [
      {text: 'Alabama', value: 'AL'},
      {text: 'Alaska', value: 'AK'},
      {text: 'Arizona', value: 'AZ'},
      {text: 'Arkansas', value: 'AR'},
      {text: 'California', value: 'CA'},
      {text: 'Colorado', value: 'CO'},
      {text: 'Connecticut', value: 'CT'},
      {text: 'Delaware', value: 'DE'},
      {text: 'District Of Columbia', value: 'DC'},
      {text: 'Florida', value: 'FL'},
      {text: 'Georgia', value: 'GA'},
      {text: 'Hawaii', value: 'HI'},
      {text: 'Idaho', value: 'ID'},
      {text: 'Illinois', value: 'IL'},
      {text: 'Indiana', value: 'IN'},
      {text: 'Iowa', value: 'IA'},
      {text: 'Kansas', value: 'KS'},
      {text: 'Kentucky', value: 'KY'},
      {text: 'Louisiana', value: 'LA'},
      {text: 'Maine', value: 'ME'},
      {text: 'Maryland', value: 'MD'},
      {text: 'Massachusetts', value: 'MA'},
      {text: 'Michigan', value: 'MI'},
      {text: 'Minnesota', value: 'MN'},
      {text: 'Mississippi', value: 'MS'},
      {text: 'Missouri', value: 'MO'},
      {text: 'Montana', value: 'MT'},
      {text: 'Nebraska', value: 'NE'},
      {text: 'Nevada', value: 'NV'},
      {text: 'New Hampshire', value: 'NH'},
      {text: 'New Jersey', value: 'NJ'},
      {text: 'New Mexico', value: 'NM'},
      {text: 'New York', value: 'NY'},
      {text: 'North Carolina', value: 'NC'},
      {text: 'North Dakota', value: 'ND'},
      {text: 'Ohio', value: 'OH'},
      {text: 'Oklahoma', value: 'OK'},
      {text: 'Oregon', value: 'OR'},
      {text: 'Pennsylvania', value: 'PA'},
      {text: 'Rhode Island', value: 'RI'},
      {text: 'South Carolina', value: 'SC'},
      {text: 'South Dakota', value: 'SD'},
      {text: 'Tennessee', value: 'TN'},
      {text: 'Texas', value: 'TX'},
      {text: 'Utah', value: 'UT'},
      {text: 'Vermont', value: 'VT'},
      {text: 'Virginia', value: 'VA'},
      {text: 'Washington', value: 'WA'},
      {text: 'West Virginia', value: 'WV'},
      {text: 'Wisconsin', value: 'WI'},
      {text: 'Wyoming', value: 'WY'}
    ];

    return statelist;
  }

  public static getHash(str){
    var hash = 0, i, chr, len;
    if (str.length === 0) return hash;
    for (i = 0, len = str.length; i < len; i++) {
      chr   = str.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  public static formatPhoneNumber ( s ) {
    var s2 = (""+s).replace(/\D/g, '');
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? "" : "(" + m[1] + ") " + m[2] + "-" + m[3];
  }
}


// WEBPACK FOOTER //
// ./src/providers/utils.ts